module.exports = __webpack_public_path__ + "fonts/Nimbus-Sans-D-OT-Light_32752.bfe34075.ttf";